import React, { FC, useContext } from 'react';
import { P, Spacing } from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import ChangePasswordContext from '../../../../utils/ChangePasswordContext';
import StatusValidationText from './StatusValidationText';

export interface NewPasswordValidationProps { }

const NewPasswordValidation: FC<NewPasswordValidationProps> = () => {
  const { t } = useTranslation('ChangePasswordSection');
  const { rules } = useContext(ChangePasswordContext);
  return (

    <>
      <P>{t('ReglePrefix')}</P>
      <StatusValidationText rule={(rules?.Regle8CharMin)} id="Regle8CharMin" />
      <StatusValidationText rule={rules?.Regle3Element} id="Regle3Element" />
      <Spacing m-l={24}>
        <StatusValidationText rule={rules?.RegleLettreMinuscules} id="RegleLettreMinuscules" />
        <StatusValidationText rule={rules?.RegleLettreMajuscules} id="RegleLettreMajuscules" />
        <StatusValidationText rule={rules?.RegleChiffre} id="RegleChiffre" />
        <StatusValidationText rule={rules?.RegleCharSpec} id="RegleCharSpec" />
      </Spacing>
    </>
  );
};
export default NewPasswordValidation;
